/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { PageSlugParams } from "../types/page.types";

/**
 * Looks at the url params and pulls out the slug and prefixes it with a slash.
 * When the slug is not found empty string is returned.
 *
 *   Example: If the current URL is /en-US/uefn this function returns /uefn
 *
 * @param params
 * @returns String
 */
export const getSlugParam = (params: PageSlugParams): string => {
	let pageSlugParam = "";
	if (params.slug && typeof params.slug === "string") {
		pageSlugParam = params.slug;
	} else if (params.slug && Array.isArray(params.slug)) {
		pageSlugParam = params.slug.join("/");
	}

	if (!pageSlugParam) {
		return "";
	}

	if (pageSlugParam.startsWith("/")) {
		return pageSlugParam;
	}

	return `/${pageSlugParam}`;
};

/**
 * Returns true if the currentPath is in the disablePaths array
 *
 *   Example: If the currentPath is /en-US/uefn and a disablePaths of ['/uefn']  is passed,
 *   this function returns true
 *
 * @param currentPath  - The current URL path
 * @param disablePaths - A list of paths which should return true if they're the current path
 * @returns Boolean
 */
export const isPathDisabled = (currentPath: string, disablePaths?: string[]): boolean => {
	if (!disablePaths?.length) return false;
	if (disablePaths.some((path) => currentPath.includes(path))) return true;
	return false;
};
